export function isNumeric(n) {
    return !(n === "" || Number.isNaN(Number(n)));
}
//# sourceMappingURL=isNumeric.js.map